import { NgModule } from '@angular/core';

import { ApiRelatedProductsService } from './infrastructure/api-relateds-products/api-relateds-products.service';
import {
    RelatedProductsRepository,
} from './infrastructure/related-products-repository/related-products-repository.service';

import { RELATED_PRODUCTS_REPOSITORY } from '@shared/product/related-products/ui/tokens/related-products.tokens';

@NgModule({
    imports: [],
    providers: [
        ApiRelatedProductsService,
        {
            provide: RELATED_PRODUCTS_REPOSITORY,
            useFactory: (apiRelatedProductsService) => new RelatedProductsRepository(apiRelatedProductsService),
            deps: [ApiRelatedProductsService],
        },
    ],
})
export class RelatedProductsCoreModule {
}
